import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./vp7200.css";

function N62() {
  const [mainImage, setMainImage] = useState("/images/n62/6-1.png");
  const [activeTab, setActiveTab] = useState("features");

  const thumbnails = [
    "/images/n62/6-2.png",
    "/images/n62/6-3.png",
    "/images/n62/6-4.png",
    "/images/n62/6-5.png",
    "/images/n62/6-6.png"
  ];
  return (
    <>
      <Header />
      <section className="vp7200-container">

        {/* LEFT SIDE */}
        <div className="vp7200-left">
          <div className="main-image">
            <img src={mainImage} alt="VP7200" />
          </div>

          {/* <div className="thumbnails">
            {thumbnails.map((img, index) => (
              <img
                key={index}
                src={img}
                alt=""
                onClick={() => setMainImage(img)}
              />
            ))}
          </div> */}
          <div className="thumbnails">

            {/* TOP ROW (2 IMAGES) */}
            <div className="thumb-row top-row">
              {thumbnails.slice(0, 3).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt=""
                  onClick={() => setMainImage(img)}
                />
              ))}
            </div>

            {/* BOTTOM ROW (3 IMAGES) */}
            <div className="thumb-row bottom-row">
              {thumbnails.slice(3, 5).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt=""
                  onClick={() => setMainImage(img)}
                />
              ))}
            </div>

          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="vp7200-right">

          {/* TOP CONTENT */}
          <div className="content-top">
            <h1>N62</h1>
            <h3>The NEXGO N62 is a compact smart payment terminal designed for flexible payment acceptance across mobile, self-service and fully unattended
environments.</h3>

            <p>
              Powered by Android and equipped with a responsive touchscreen display, wireless connectivity and support for chip and contactless payments, the N62 delivers a modern payment experience while providing businesses with the flexibility to deploy the device in portable, semi-attended or integrated unattended payment scenarios.
            </p>

            <p>
              With the latest capabilities supporting integration into automated machines and kiosks, the N62 can now operate as a fully embedded unattended payment solution, enabling secure cashless transactions across vending, ticketing, automated retail and other self-service environments.
            </p>
          </div>

          {/* TABS */}
          <div className="tabs">
            <button
              className={activeTab === "features" ? "active" : ""}
              onClick={() => setActiveTab("features")}
            >
              KEY FEATURES
            </button>

            <button
              className={activeTab === "specs" ? "active" : ""}
              onClick={() => setActiveTab("specs")}
            >
              SPECIFICATIONS
            </button>
          </div>

          {/* TAB CONTENT */}
          <div className="tab-content">
            {activeTab === "features" && (
              <ul>
                <li>Android 10 smart payment platform</li>
                <li>4" capacitive multi-touch display for intuitive user interaction</li>
                <li>Supports chip and contactless payments for fast and secure transactions</li>
                <li>Software PIN pad with fixed PIN support</li>
                <li>Compact, lightweight design suitable for integration into kiosks and machines</li>
                <li>Front camera for scanning and customer interaction</li>
                <li>4G, Wi-Fi and Bluetooth connectivity for reliable communication</li>
                <li>GPS, GLONASS and BeiDou positioning support</li>
                <li>Rechargeable battery for portable deployments</li>
                <li>Optional integrated payment module base and charging base</li>
                <li>Supports unattended deployment within automated payment environments</li>
              </ul>
            )}

            {activeTab === "specs" && (
              <ul>
                <li>Connectivity: USB-C, Ethernet, LTE</li>
                <li>Operating Temp: -30°C to 70°C</li>
                <li>Security: PCI PTS 6.x</li>
                <li>Ingress Protection: IP65</li>
                <li>Dimensions: Compact form factor</li>
              </ul>
            )}
          </div>
        </div>
      </section>
      <section className="vp7200-benefits">

        <div className="vp7200-benefits-container">

          {/* LEFT CONTENT */}
          <div className="benefits-left">
            <h2>N62 - Smart, Flexible Payment for Any Environment</h2>

            <p>
              Compact yet powerful, the N62 delivers seamless cashless payments across mobile, self-service, and unattended environments-giving your business the flexibility to scale and integrate with ease.
            </p>

            <ul>
              <li>All-in-One Flexibility</li>
              <li>Works across mobile, semi-attended, and fully unattended setups</li>
              <li>Modern Payment Experience</li>
              <li>Fast, secure chip and contactless transactions with intuitive touchscreen</li>
              <li>Built for Integration</li>
              <li>Compact design makes it ideal for kiosks, vending, and automated machines.</li>
              <li>Reliable Connectivity Anywhere</li>
              <li>4G, Wi-Fi, and Bluetooth ensure consistent performance</li>
              <li>Portable & Powerful</li>
              <li>Rechargeable battery with Android platform for smart functionality</li>
            </ul>

            {/* PAYMENT METHODS */}
            <h3 className="payment-title">Multiple Payment Methods</h3>

            <div className="payment-logos">
              <img src="/images/7200/gpay.png" alt="GPay" />
              <img src="/images/7200/mc.png" alt="Mastercard" />
              <img src="/images/7200/amex.png" alt="Amex" />
              <img src="/images/7200/visa.png" alt="Visa" />
              <img src="/images/7200/apple.png" alt="Apple Pay" />
              <img src="/images/7200/samsung.png" alt="Samsung Pay" />
              <img src="/images/7200/alipay.png" alt="Alipay" />
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="benefits-right">
            <img
              src="/images/n62/6-7.png"
              alt="Kiosk"
            />
          </div>
        </div>
      </section>
      <section className="vp7200-features">
        <div className="vp7200-features-container">
          <div className="feature-item">
            <img src="/images/7200/flex-connect.png" alt="Connectivity" />
            <h4>Flexible Connectivity</h4>
            <p>Integrate seamlessly into your existing infrastructure.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/secure.png" alt="Security" />
            <h4>Secure & Compliant</h4>
            <p>Protect your business and customers with advanced security.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/rugged.png" alt="Rugged" />
            <h4>Rugged & Reliable</h4>
            <p>Built to withstand tough environments and 24/7 use.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/cust.png" alt="Customer" />
            <h4>Customer Engagement</h4>
            <p>Enhance the payment experience and drive loyalty.</p>
          </div>
        </div>
      </section>
      <section className="vp7200-specs">

        <div className="vp7200-specs-container">

          <h2 className="specs-title">Technical Specifications</h2>

          {/* ELECTRICAL */}
          <div className="spec-group">
            <div className="spec-label">ELECTRICAL</div>

            <div className="spec-content electrical">
              <div className="spec-row">
                <span>OS</span>
                <p>ANDROID 10</p>
              </div>

              <div className="spec-row">
                <span>PROCESSOR</span>
                <p>QUAD-CORE CORTEX-A53, 1.5GHZ</p>
              </div>

              <div className="spec-row">
                <span>COMMUNICATION</span>
                <p>4G/3G/2G WI-FI, 802.11A/B/G/N, 2.4GHZ & 5GHZ BT4.X</p>
              </div>

              <div className="spec-row">
                <span>ADAPTOR</span>
                <p>DC 5.0V/1.QA</p>
              </div>

              <div className="spec-row">
                <span>BATTERY</span>
                <p>3.8V/2000MAH RECHARGEABLE LI-ION BATTERY</p>
              </div>

              <div className="spec-row">
                <span>CERTIFICATIONS</span>
                <p>PCL6.X, CE, FCC, EMV LL/L2, EMV CLL, PAYPASS, PAYWAVE, ETC.,</p>
              </div>

              <div className="spec-row">
                <span>POSITIONING</span>
                <p>GPS, GLONASS OR BEIDOU</p>
              </div>

              <div className="spec-row">
                <span>PIN PAD</span>
                <p>SOFTWARE PIN PAD / FIXED PIN SUPPORTED</p>
              </div>
            </div>
          </div>

          {/* ENVIRONMENTAL */}
          <div className="spec-group">
            <div className="spec-label">ENVIRONMENTAL</div>

            <div className="spec-content environmental">
              <div className="spec-row">
                <span>OPERATING TEMPERATURE</span>
                <p>0°C TO 50°C</p>
              </div>

              <div className="spec-row">
                <span>STORAGE TEMPERATURE</span>
                <p>-20°C TO 70°C</p>
              </div>

              <div className="spec-row">
                <span>RELATIVE HUMIDITY</span>
                <p>5% TO 95% (NON-CONDENSING)</p>
              </div>

              <div className="spec-row">
                <span>OPERATING TEMPERATURE</span>
                <p>-30°C TO 70°C (MAX CHANGE OF 10°C PER/HOUR)</p>
              </div>

            </div>
          </div>

          {/* MECHANICAL */}
          <div className="spec-group">
            <div className="spec-label">MECHANICAL</div>

            <div className="spec-content mechanical">
              <div className="spec-row">
                <span>DIMENSIONS</span>
                <p>103 X 124 X 44 MM, 443G</p>
              </div>

              <div className="spec-row">
                <span>MEMORY</span>
                <p>1GB RAM + 8GB ROM<br/>2GB RAM + 16GB ROM</p>
              </div>

              <div className="spec-row">
                <span>DISPLAY</span>
                <p>4" (480 X 480) COLOR SCREEN, CAPACITIVE TOUCHSCREEN, MULTI-TOUCH</p>
              </div>

              <div className="spec-row">
                <span>CAMERAS</span>
                <p>FRONT: 2MP, FF</p>
              </div>

              <div className="spec-row">
                <span>CARD SLOTS</span>
                <p>CARD SLOTS 2 X SIM</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default N62;